import { UUID } from '@finxone-platform/shared/base-types';
import {
  ButtonSizeOptions,
  ButtonTypes,
  WidgetNames,
  WidgetTitles,
} from '@finxone-platform/shared/sys-config-types';

export const newSupportChatChildComponents = [
  {
    widgetTypeConfig: 'new',
    uniqueId: new UUID().toString(),
    name: WidgetNames.INPUT_WIDGET,
    widgetConfiguration: {
      widgetDisplayName: WidgetTitles.INPUT_WIDGET,
      widgetConfigDisplayName: WidgetTitles.INPUT_WIDGET,
      attributes: {
        elementsConfig: [],
        name: WidgetNames.INPUT_WIDGET,
        css_config: {},
        widgetProperties: {
          textContent: '',
          inputFieldConfig: {
            id: 'subject',
            type: 'select',
            label: 'Subject',
            parentForm: 'newSupportChatForm',
            name: 'subject',
            validation: {
              required: true,
              phoneNumber: false,
              email: false,
            },
            isScrollable: true,
            isScrollPeekEnabled: false,
            visibleItemsCount: 5,
            menuDirection: 'auto',
            inputFormat: 'dropdown',
            fieldRequired: true,
            isPreselectDisabled: false,
            searchEnabled: false,
            showEmailVerifyButton: false,
            inputPlaceholder: '',
            inputHelperText: '',
            inputLabelTooltipText: '',
            spaceBetweenElementUnit: 'px',
            spaceBetweenElementValue: '10',
            radioCheckboxOptionsLayout: 'vertical',
            showPhoneVerifyButton: false,
            defaultCurrency: 'GBP',
            minValue: '0',
            maxValue: '100',
            stepValue: '1',
            sliderValueType: 'percentage',
            dataDropdownOption: 'support-chat-subjects',
            dropdownOptionItemTemplate: '{{label}}',
            configureAnswerActiveTab: 'Library',
          },
          disableAutocomplete: false,
        },
      },
      isRemovable: true,
      nestedWidgets: {},
    },
    widgetIconPath: 'input-field-widget',
  },
  {
    widgetTypeConfig: 'new',
    uniqueId: new UUID().toString(),
    name: WidgetNames.SECTION,
    widgetConfiguration: {
      widgetDisplayName: WidgetTitles.SECTION,
      widgetConfigDisplayName: WidgetTitles.SECTION,
      attributes: {
        outerCss: 'height: 100px;',
        elementsConfig: [],
        css_config: {},
        widgetProperties: {
          textContent: '',
        },
        usingResponsiveHideCondition: true,
        hideCondition: '',
        responsiveHideCondition:
          "newSupportChatForm.relatesToAccount === false || newSupportChatForm.subject === ''",
      },
      isRemovable: true,
    },
    widgetIconPath: 'section-widget',
    childComponents: [
      {
        widgetTypeConfig: 'new',
        uniqueId: new UUID().toString(),
        name: WidgetNames.ACCOUNTS_CONTEXT_DROPDOWN,
        widgetConfiguration: {
          attributes: {
            role: 'thisbank',
            zone: 'landing_zone',
            context: 'savings-account',
            showFlag: false,
            css_config: {
              color: 'var(--color-on-surface)',
              width: 60,
              height: 42,
              display: 'flex',
              fontSize: 18,
              fontUnit: 'px',
              iconUnit: 'px',
              textFont: 'var(--font-family)',
              marginTop: 0,
              alertColor: '#2C70C9',
              fontWeight: '500',
              isTextBold: true,
              marginLeft: 0,
              marginUnit: 'px',
              paddingTop: 8,
              shadowBlur: 0,
              borderColor: 'var(--color-border-color)',
              borderStyle: 'solid',
              borderWidth: 1,
              marginRight: 0,
              paddingLeft: 10,
              paddingUnit: 'px',
              leftIconUnit: 'px',
              lefticonSize: 20,
              marginBottom: 0,
              paddingRight: 5,
              shadowSpread: 0,
              dimensionUnit: 'px',
              isiTextItalic: false,
              paddingBottom: 8,
              rightIconUnit: 'px',
              righticonSize: 24,
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              textAlignment: 'left',
              justifyContent: 'space-between',
              backGroundColor: '#ffffff00',
              backgroundColor: 'transparent',
              disabledBgColor: '',
              isTextUnderline: false,
              selectedOpacity: 100,
              borderRadiusUnit: 'px',
              disabledTextColor: '',
              selectedobjectfit: 'default',
              textInputFontSize: 16,
              textInputFontUnit: 'px',
              verticalAlignment: 'center',
              borderRadiusTopLeft: 10,
              inactiveBorderColor: 'var(--color-on-surface-muted)',
              borderRadiusTopRight: 10,
              borderRadiusBottomLeft: 10,
              borderRadiusBottomRight: 10,
              inactiveBackgroundColor: '',
              textInputBackgroundColor: '#ffffff00',
            },
            iconConfig: {
              leftIcon: 'change-pin',
              rightIcon: '',
              leftIconSize: '20px',
            },
            textContent: 'Account',
            elementsConfig: [],
            isFundingEnabled: true,
            widgetProperties: {
              textContent: '',
              inputFieldSettings: {
                css_config: {
                  iconSize: 24,
                  inputWidth: 100,
                  borderColor: 'var(--color-border-color)',
                  borderWidth: 1,
                  inputHeight: '42',
                  iconSizeUnit: 'px',
                  inputTextColor: 'var(--color-on-surface)',
                  backgroundColor: 'transparent',
                  borderStyleUnit: 'px',
                  borderRadiusTopLeft: 10,
                  inactiveBorderColor: 'var(--color-border-color)',
                  borderRadiusTopRight: 10,
                  borderRadiusBottomLeft: 10,
                  borderRadiusBottomRight: 10,
                  inactiveBackgroundColor: 'transparent',
                },
                isIconAllowed: false,
                companyNameLabel: '',
              },
              inputFieldConfig: {
                isScrollable: true,
                isScrollPeekEnabled: false,
                visibleItemsCount: 5,
                menuDirection: 'auto',
              },
              floatValue: 0,
              parentForm: 'newSupportChatForm',
            },
            enableTotalWealth: false,
            accountContextList: [
              {
                id: 'active',
                name: 'Active',
              },
            ],
            isWithdrawalEnabled: false,
            widgetVisualTemplate:
              '<div style="width: 100%;">\n    <div class="body1" style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; gap: 8px;">\n        <div style="display: flex; flex-direction: column; gap: 4px;">\n\n            <div style="color: var(--color-on-background); font-weight: 600; word-wrap: break-word;">\n                {{ accountName }}\n            </div>\n\n            <div class="labelText" style="word-wrap: break-word; color: var(--color-on-surface-muted);">\n                {{ accountNumber }} | {{ addDashesToSortCode sortCode }}\n            </div>\n        </div>\n\n    </div>\n</div>',
            widgetDropdownTemplate:
              '<div style="width: 100%; overflow-x: hidden; margin-right: 16px;">\n    <div class="body1" style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; gap: 8px;">\n        <div style="display: flex; flex-direction: column; gap: 4px;">\n\n            <div style="color: var(--color-on-background); font-weight: 600; word-wrap: break-word;">\n                {{ accountName }}\n            </div>\n\n            <div class="labelText" style="word-wrap: break-word; color: var(--color-on-surface-muted);">\n                {{ accountNumber }} | {{ addDashesToSortCode sortCode }}\n            </div>\n        </div>\n        <div class="labelText" style="color: var(--color-on-background); font-weight: 600; word-wrap: break-word; margin-left: auto; padding-left: 16px; white-space: nowrap; align-text: right;">\n            {{ currencyPipe availableBalance currencyCode=currency }}\n        </div>\n\n    </div>\n</div>',
            totalWealthCustomCurrency: null,
            enableAccountContextSwitch: true,
            showAllOpenEasyAccessAccounts: true,
            totalWealthDefaultCurrencyOption: 'account-context-currency',
            inputId: '',
            pageSize: 10,
          },
          isRemovable: true,
          widgetDisplayName: WidgetTitles.ACCOUNTS_CONTEXT_DROPDOWN,
          widgetConfigDisplayName: WidgetTitles.ACCOUNTS_CONTEXT_DROPDOWN,
        },
        widgetIconPath: 'generic-widget',
        gridPosition: {
          x: 0,
          y: 6,
          cols: 15,
          rows: 3,
          dragEnabled: true,
          resizeEnabled: true,
        },
      },
    ],
  },
  {
    widgetTypeConfig: 'new',
    uniqueId: new UUID().toString(),
    name: WidgetNames.SPACER,
    widgetConfiguration: {
      widgetDisplayName: WidgetTitles.SPACER,
      widgetConfigDisplayName: WidgetTitles.SPACER,
      attributes: {
        outerCss: '',
        elementsConfig: [],
        css_config: { height: 15, heightUnit: 'px' },
        widgetProperties: { textContent: '' },
      },
      isRemovable: true,
    },
    widgetIconPath: 'spacer-widget',
  },
  {
    widgetTypeConfig: 'new',
    uniqueId: new UUID().toString(),
    name: WidgetNames.ACTION_BUTTON,
    widgetConfiguration: {
      uniqueId: new UUID().toString(),
      widgetDisplayName: WidgetTitles.MANDATORY_CTA_BUTTON,
      widgetConfigDisplayName: 'Action Button',
      isRemovable: true,
      attributes: {
        elementsConfig: [],
        label: '',
        sub_heading: '',
        show: true,
        css_config: {
          fontUnit: 'px',
          textInputFontUnit: 'px',
          righticonSize: 20,
          lefticonSize: 20,
          iconUnit: 'px',
          leftIconUnit: 'px',
          rightIconUnit: 'px',
          width: 60,
          height: 60,
          dimensionUnit: 'px',
        },
        widgetProperties: {
          textContent: 'Submit',
          buttonActionType: 'start-a-new-support-chat',
          zoneToNavigate: 'beneficiary_zone',
          urlToNavigate: 'beneficiary-list',
          globalStyling: true,
          globalStylingClass: `${ButtonTypes.PRIMARY} ${ButtonSizeOptions.FULL_WIDTH}`,
          calculationAppliesTo: 'renew',
          successAlertType: null,
          errorAlertType: null,
          actionNavigationConfigurations: {},
        },
      },
    },
    gridPosition: {
      x: 0,
      y: 0,
      minItemCols: 1,
      minItemRows: 1,
      rows: 3,
      cols: 15,
      resizeEnabled: true,
      dragEnabled: true,
    },
    widgetIconPath: 'generic-widget',
  },
];
